import { ComponentUserDetail, StyledUserDetailPage } from "@components";

export const PageUserDetail = () => {
    return (
        <StyledUserDetailPage>
            <ComponentUserDetail />
        </StyledUserDetailPage>
    );
};
